import { render, staticRenderFns } from "./Toper.vue?vue&type=template&id=155d066c&scoped=true&"
import script from "./Toper.vue?vue&type=script&lang=js&"
export * from "./Toper.vue?vue&type=script&lang=js&"
import style0 from "./Toper.vue?vue&type=style&index=0&id=155d066c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155d066c",
  null
  
)

export default component.exports